import script from "./PendingButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./PendingButton.vue?vue&type=script&lang=ts&setup=true"

import "./PendingButton.vue?vue&type=style&index=0&id=142978dd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-142978dd"]])

export default __exports__